import { render, staticRenderFns } from "./UssdCallbackDialog.vue?vue&type=template&id=4d04c491&scoped=true&"
import script from "./UssdCallbackDialog.vue?vue&type=script&lang=ts&"
export * from "./UssdCallbackDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d04c491",
  null
  
)

export default component.exports